import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ContainerComponent } from "./container/container.component";
import { CollapseModule } from "ngx-bootstrap";
import { BootstrapModule } from "../common/bootstrap.module";

@NgModule({
  declarations: [ContainerComponent],
  imports: [CommonModule, RouterModule, CollapseModule, BootstrapModule],
  exports: [ContainerComponent]
})
export class LayoutModule {}
